export interface ITickCircleColorParams {
  tickColor?: string;
  backgroundColor?: string;
}

export const TickCircleColorParams = ({
  tickColor = "xxxxxxx",
  backgroundColor = "xxxxxxx",
}: ITickCircleColorParams) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="94"
    height="94"
    viewBox="0 0 94 94"
  >
    <g
      id="vuesax_bulk_tick-circle"
      data-name="vuesax/bulk/tick-circle"
      transform="translate(-748 -188)"
    >
      <g id="tick-circle" transform="translate(748 188)">
        <g
          id="Vector"
          transform="translate(7.833 7.833)"
          fill="rgba(24,153,215,0.4)"
        >
          <path
            d="M 39.16666412353516 77.83333587646484 C 33.94647598266602 77.83333587646484 28.88270378112793 76.81106567382812 24.11600494384766 74.794921875 C 19.51167488098145 72.84744262695312 15.37644386291504 70.05936431884766 11.82520389556885 66.50812530517578 C 8.273963928222656 62.95688247680664 5.485884189605713 58.82166290283203 3.538414239883423 54.21732330322266 C 1.522274136543274 49.45062255859375 0.5000041127204895 44.3868522644043 0.5000041127204895 39.16666412353516 C 0.5000041127204895 33.94647598266602 1.522274136543274 28.88270378112793 3.538414239883423 24.11600494384766 C 5.485884189605713 19.51167488098145 8.273963928222656 15.37644386291504 11.82520389556885 11.82520389556885 C 15.37644386291504 8.273963928222656 19.51167488098145 5.485884189605713 24.11600494384766 3.538414239883423 C 28.88270378112793 1.522274136543274 33.94647598266602 0.5000041127204895 39.16666412353516 0.5000041127204895 C 44.3868522644043 0.5000041127204895 49.45062255859375 1.522274136543274 54.21732330322266 3.538414239883423 C 58.82166290283203 5.485884189605713 62.95688247680664 8.273963928222656 66.50812530517578 11.82520389556885 C 70.05936431884766 15.37644386291504 72.84744262695312 19.51167488098145 74.794921875 24.11600494384766 C 76.81106567382812 28.88270378112793 77.83333587646484 33.94647598266602 77.83333587646484 39.16666412353516 C 77.83333587646484 44.3868522644043 76.81106567382812 49.45062255859375 74.794921875 54.21732330322266 C 72.84744262695312 58.82166290283203 70.05936431884766 62.95688247680664 66.50812530517578 66.50812530517578 C 62.95688247680664 70.05936431884766 58.82166290283203 72.84744262695312 54.21732330322266 74.794921875 C 49.45062255859375 76.81106567382812 44.3868522644043 77.83333587646484 39.16666412353516 77.83333587646484 Z"
            stroke="none"
          />
          <path
            d="M 39.16666412353516 1 C 34.01375198364258 1 29.01551818847656 2.00897216796875 24.31078720092773 3.998908996582031 C 19.76604080200195 5.921173095703125 15.68424224853516 8.67327880859375 12.17875671386719 12.17875671386719 C 8.67327880859375 15.68424224853516 5.921173095703125 19.76604080200195 3.998908996582031 24.31078720092773 C 2.00897216796875 29.01551818847656 1 34.01375198364258 1 39.16666412353516 C 1 44.31957626342773 2.00897216796875 49.31781005859375 3.998908996582031 54.02254104614258 C 5.921173095703125 58.56728363037109 8.67327880859375 62.64908599853516 12.17875671386719 66.15457153320312 C 15.68424224853516 69.66004943847656 19.76604080200195 72.41215515136719 24.31078720092773 74.33441925048828 C 29.01551818847656 76.32435607910156 34.01375198364258 77.33332824707031 39.16666412353516 77.33332824707031 C 44.31957626342773 77.33332824707031 49.31781005859375 76.32435607910156 54.02255249023438 74.33441925048828 C 58.56728363037109 72.41215515136719 62.64908599853516 69.66004943847656 66.15457153320312 66.15457153320312 C 69.66004943847656 62.64908599853516 72.41215515136719 58.56728363037109 74.33441925048828 54.02255249023438 C 76.32435607910156 49.31781005859375 77.33332824707031 44.31957626342773 77.33332824707031 39.16666412353516 C 77.33332824707031 34.01375198364258 76.32435607910156 29.01551818847656 74.33441925048828 24.31078720092773 C 72.41215515136719 19.76604080200195 69.66004943847656 15.68424224853516 66.15457153320312 12.17875671386719 C 62.64908599853516 8.67327880859375 58.56728363037109 5.921173095703125 54.02254104614258 3.998908996582031 C 49.31781005859375 2.00897216796875 44.31957626342773 1 39.16666412353516 1 M 39.16666412353516 0 C 60.79782104492188 0 78.33332824707031 17.53551864624023 78.33332824707031 39.16666412353516 C 78.33332824707031 60.79782104492188 60.79782104492188 78.33332824707031 39.16666412353516 78.33332824707031 C 17.53551864624023 78.33332824707031 0 60.79782104492188 0 39.16666412353516 C 0 17.53551864624023 17.53551864624023 0 39.16666412353516 0 Z"
            stroke="none"
            fill="#1899d7"
          />
        </g>
        <path
          id="Vector-2"
          data-name="Vector"
          d="M14.012,28.073a2.935,2.935,0,0,1-2.076-.862L.852,16.127A2.936,2.936,0,0,1,5,11.975l9.008,9.008L34.144.852A2.936,2.936,0,0,1,38.3,5L16.088,27.211A2.935,2.935,0,0,1,14.012,28.073Z"
          transform="translate(27.426 32.949)"
          fill="#1899d7"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H94V94H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </svg>
);

export const ThreeDotsLoaderAnimatedSvg = (
  props: React.SVGProps<SVGSVGElement>
) => {
  const {
    width = 120,
    height = 30,
    viewBox = `0 0 ${width} ${height}`,
    fill = "#fff",
  } = props;

  const radius = Number(height) / 2;
  const widthValue = Number(width);
  const heightValue = Number(height);

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={widthValue / 8} cy={heightValue / 2} r={radius}>
        <animate
          attributeName="r"
          from={radius}
          to={radius}
          begin="0s"
          dur="0.8s"
          values={`${radius}; ${radius / 1.5}; ${radius}`}
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          from="1"
          to="1"
          begin="0s"
          dur="0.8s"
          values="1;.5;1"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        cx={widthValue / 2}
        cy={heightValue / 2}
        r={radius / 1.5}
        fillOpacity="0.3"
      >
        <animate
          attributeName="r"
          from={radius / 1.5}
          to={radius / 1.5}
          begin="0s"
          dur="0.8s"
          values={`${radius / 1.5}; ${radius}; ${radius / 1.5}`}
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          from="0.5"
          to="0.5"
          begin="0s"
          dur="0.8s"
          values=".5;1;.5"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx={widthValue / 1.14} cy={heightValue / 2} r={radius}>
        <animate
          attributeName="r"
          from={radius}
          to={radius}
          begin="0s"
          dur="0.8s"
          values={`${radius}; ${radius / 1.5}; ${radius}`}
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          from="1"
          to="1"
          begin="0s"
          dur="0.8s"
          values="1;.5;1"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
};
